import { gql } from 'graphql.macro';

export const addOrderFormTemplate = gql`
    mutation addOrderForm($imageBase64: String!) {
        addOrderForm(imageBase64: $imageBase64) {
            _id
            title
            status
        }
    }
`;

export const deleteOrderFormTemplate = gql`
    mutation deleteOrderForm($orderFormId: MongoDbObjectId!) {
        deleteOrderForm(orderFormId: $orderFormId)
    }
`;
